import { UIButton } from '../primitives';
import { useTranslation } from 'react-i18next';

/**
 * GroupTemplateBadge — бейдж счётчика шаблонов в шапке группы.
 *
 * Figma source: `318:4663` uiButton type=secondary size=sm (115×32),
 * leftIcon=gallery, label «12 шаблонов». По figma-spec §4.1 и
 * acceptance §2.3.2 — **декоративный** бейдж, не кликабельный (`disabled`).
 *
 * Реализация = тонкая обёртка над `UIButton` primitive + склонение
 * числительных на русском. Никакой собственной геометрии — всё приходит
 * из primitive (type=secondary size=sm leftIcon=gallery).
 *
 * Props:
 *   - count — число шаблонов в группе (integer ≥ 0)
 */
function pluralize(n, t) {
  const mod100 = n % 100;
  const mod10 = n % 10;
  if (mod100 >= 11 && mod100 <= 14) return t('groupDetail.template5');
  if (mod10 === 1) return t('groupDetail.template1');
  if (mod10 >= 2 && mod10 <= 4) return t('groupDetail.template24');
  return t('groupDetail.template5');
}

export default function GroupTemplateBadge({ count }) {
  const { t } = useTranslation();
  return (
    <UIButton type="secondary" size="sm" leftIcon="gallery" disabled>
      {count} {pluralize(count, t)}
    </UIButton>
  );
}
